import { Label } from "components/DesignSystem/TextInput/TextInput";
import { useTypedFormikContext } from "hooks/useTypedFormikContext";
import { BareRichTextEditor } from "./BareRichTextEditor";

type RichTextEditorProps = {
  name: string;
  label?: string;
  placeholder?: string;
};

type RichTextValues = Record<string, string | null | undefined>;

export const RichTextEditor = ({
  name,
  label,
  placeholder,
}: RichTextEditorProps) => {
  const { values, setFieldValue } = useTypedFormikContext<RichTextValues>();

  const handleChange = (value: string) => setFieldValue(name, value);

  return (
    <div className="t-flex t-flex-col">
      {label && <Label htmlFor={name}>{label}</Label>}
      <BareRichTextEditor
        defaultValue={values[name]}
        onChange={handleChange}
        placeholder={placeholder}
      />
    </div>
  );
};
